var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.794922,
    y: 1.28711,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#00ADEF",
    stroke: "#00ADEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3438 7.1387C20.5688 7.36373 20.6952 7.6689 20.6952 7.9871C20.6952 8.30529 20.5688 8.61046 20.3438 8.8355L10.7438 18.4355C10.5188 18.6605 10.2136 18.7868 9.89541 18.7868C9.57721 18.7868 9.27204 18.6605 9.04701 18.4355L4.24701 13.6355C4.02842 13.4092 3.90747 13.1061 3.9102 12.7914C3.91294 12.4768 4.03914 12.1758 4.26163 11.9533C4.48412 11.7308 4.78509 11.6046 5.09973 11.6019C5.41437 11.5992 5.71749 11.7201 5.94381 11.9387L9.89541 15.8903L18.647 7.1387C18.872 6.91373 19.1772 6.78735 19.4954 6.78735C19.8136 6.78735 20.1188 6.91373 20.3438 7.1387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBox);
export default __webpack_public_path__ + "static/media/checkedBox.2b7d6c585106e3e52aa9741bc261f650.svg";
export { ForwardRef as ReactComponent };